export const TimePoints: Record<string, string> = {
  0: "00:00",
  1: "01:00",
  2: "02:00",
  3: "03:00",
  4: "04:00",
  5: "05:00",
  6: "06:00",
  7: "07:00",
  8: "08:00",
  9: "09:00",
  10: "10:00",
  11: "11:00",
  12: "12:00",
  13: "13:00",
  14: "14:00",
  15: "15:00",
  16: "16:00",
  17: "17:00",
  18: "18:00",
  19: "19:00",
  20: "20:00",
  21: "21:00",
  22: "22:00",
  23: "23:00",
  24: "23:59",
};

export const TimePointsLabel: Record<string, string> = {
  "00:00": "00:00AM",
  "01:00": "01:00AM",
  "02:00": "02:00AM",
  "03:00": "03:00AM",
  "04:00": "04:00AM",
  "05:00": "05:00AM",
  "06:00": "06:00AM",
  "07:00": "07:00AM",
  "08:00": "08:00AM",
  "09:00": "09:00AM",
  "10:00": "10:00AM",
  "11:00": "11:00AM",
  "12:00": "12:00PM",
  "13:00": "01:00PM",
  "14:00": "02:00PM",
  "15:00": "03:00PM",
  "16:00": "04:00PM",
  "17:00": "05:00PM",
  "18:00": "06:00PM",
  "19:00": "07:00PM",
  "20:00": "08:00PM",
  "21:00": "09:00PM",
  "22:00": "10:00PM",
  "23:00": "11:00PM",
  "23:59": "11:59PM",
};
